export default "__VITE_ASSET__7MkqTsMI__"